import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";

import { Formik } from "formik";
import FilingApi from "../../api/ITRFilingApi";
import { EToastvariant, IAssignFiling } from "../../config/interfaces";
import { useAppDispatch, useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";
import { showToastMsg } from "../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../services";
import FASvgIcon from "../FASvgIcon";
import AsyncDropdownSelect from "../fields/AsyncDropdown";
import { ButtonSpinner } from "../placeholders";

type Props = {
  showModal: boolean;
  onYesBtnClick: (_values: IAssignFiling) => void;
  handleModalClose: () => void;
  isProcessing?: boolean;
  message?: string;
  title?: string;
  onYesBtnText?: string;
  onNoBtnText?: string;
};

const initialFormSchema = Yup.object().shape({
  assign_to: Yup.string().required("Assign to is required")
});

const initialValues: IAssignFiling = {
  assign_to: "",
  assignedToData: null
};

const AssignExpertFormModal: React.FC<Props> = (props: Props) => {
  const {
    showModal,
    handleModalClose,
    isProcessing = false,
    onYesBtnClick,
    title = "Assign Tax Expert to this filing",
    onYesBtnText = "Assign",
    onNoBtnText = "Cancel"
  } = props;

  const dispatch = useAppDispatch();
  const { currentFilingData } = useAppSelector(ITRFilingSelector);

  const getTaxExperts = async (query: string) => {
    try {
      const filingApi = FilingApi.getInstance();
      const { records } = await filingApi.getTaxExperts({
        search: query,
        offset: 0,
        count: -1,
        orderBy: "createdAt",
        order: "DESC",
        role: "ca",
        inactive: false
      });
      const _records = records.filter((record) => record?.uuid !== currentFilingData?.userUuid);
      return _records;
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  const handleFormSubmit = async (values: IAssignFiling) => {
    onYesBtnClick(values);
  };

  //this function return jsx that u want to display
  const CustomContent = (data: any) => {
    return (
      <div className="detailed-option">
        {data.fullName || ""}
        {data.email && <small>{data.email}</small>}
        {data.phoneNumber && <small>{data.phoneNumber}</small>}
      </div>
    );
  };

  const optionLabel = (option: any) => `${option?.fullName || ""} `;

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        centered
        backdrop="static"
        className="form-modal"
        size="sm"
      >
        {/* <Button
          variant="primary"
          className="icon-only close-modal"
          onClick={handleModalClose}
          disabled={isProcessing}
        >
          <FASvgIcon icon={faXmark} />
        </Button> */}
        <Modal.Header className="justify-content-start">
          <Modal.Title className="text-start">{title}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={initialFormSchema}
          onSubmit={handleFormSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
            setTouched
          }) => (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Modal.Body>
                <Row className="modal-fields-wrap">
                  <Col className="py-3">
                    <AsyncDropdownSelect
                      label="Tax Expert"
                      placeholder="Search by name, email, phone..."
                      name="activeTaxExperts"
                      isSearchable={true}
                      onSearch={async (_query) => {
                        const apiResponse = await getTaxExperts(_query);
                        return apiResponse;
                      }}
                      value={values?.assign_to ? values.assignedToData : null}
                      onChange={async (_picked) => {
                        if (_picked) {
                          setFieldValue("assign_to", _picked.uuid);
                          setFieldValue("assignedToData", _picked);
                        } else {
                          setFieldValue("assign_to", "");
                          setFieldValue("assignedToData", null);
                        }
                        setTouched({});
                      }}
                      onBlur={handleBlur("assign_to")}
                      optionLabel={optionLabel}
                      isClearable={true}
                      customContent={CustomContent}
                      isInvalid={Boolean(errors.assign_to) && touched.assign_to}
                      errorMsg={String(errors.assign_to)}
                      formType="GENERAL"
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="modal-btns-wrap justify-content-between">
                <Button
                  variant="outline-greyDark"
                  disabled={isProcessing}
                  className="btn-w-160"
                  onClick={handleModalClose}
                >
                  {onNoBtnText}
                </Button>
                <Button
                  variant="primary"
                  className="btn-w-160"
                  type="submit"
                  disabled={isProcessing}
                >
                  {!isProcessing ? (
                    <>
                      {onYesBtnText}
                      <FASvgIcon icon={faArrowRight} />
                    </>
                  ) : (
                    <ButtonSpinner />
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default AssignExpertFormModal;
